const initialState = {
  title: "",
  copies: 1,
};

export function UniqueTableReducer(state = initialState, { type, payload }) {
  switch (type) {
    case "UNIQUE_TABLE_LIST": {
      const { key, data } = payload;
      return {
        ...state,
        [key]: data,
      };
    }
    case "UNIQUE_TABLE_LATEST_TITLE": {
      return {
        ...state,
        title: payload.title,
      };
    }
    case "PRINT_COPY": {
      return {
        ...state,
        copies: payload,
      };
    }
    case "CLEAR_UNIQUE_TABLE_LIST": {
      return initialState;
    }
    case "DELETE_UNIQUE_TABLE_KEY": {
      const { [payload.key]: _, ...rest } = state;
      return rest;
    }
    default:
      return state;
  }
}
